<template>
    <dashboard-layout>
        <div class="container-fluid">
          <div class="col-md-6">
                    <router-link to="/dashboard" class="icon text-gray-600">
                    <i class="fas fa-arrow-left"></i> Back
                    </router-link>
                </div><br>
  
        <div class="card shadow light">
        <div class="card-body">
      <div class="top-section">
        <center>
        <div class="row">
          <div class="col" @click="handleInProgressClick">
            {{ inProgressCount }} IN PROGRESS
          </div>
          <div class="col" @click="handleAwaitingClick">
            {{ awaitingCount }} AWAITING
          </div>
          <div class="col" @click="handleHistoryClick">
            <i class="fas fa-history"></i> History
          </div>
        </div>
    </center>
      </div>
      <hr class="sidebar-divider">
  
     
      <div class="middle-section">
        <div class="row">
          <div class="col-md-4">
            <img src="../../components/img/signicon.svg" alt="Signature Image" class="signature-image" />
          </div>
          <div class="col-md-8">
            <h4><strong>Send Signature Request</strong></h4>
            <p>
              Here you can send request like Change request, User Access Request, Leave Request etc for approval by signature
            </p>
            <router-link to="/e-signature/sendRequest" class="icon text-gray-600">
            <button class="send-request-button" @click="sendSignatureRequest">Send Signature Request</button>
          </router-link>
          </div>
        </div>
      </div>
      <hr class="sidebar-divider">
      <hr class="sidebar-divider"><br><br>

      <h7><strong>Templates</strong></h7>
  
      
      <div class="bottom-section">
      <div class="card-list">
  
        <div class="cardsmall">
          <img src="../../components/img/changeicon.svg" alt="Thumbnail 1" class="card-thumbnail" />
          <div class="card-label">Change Request</div>
        </div>


      </div>
    </div>
      </div>
      </div>
    </div>
    </dashboard-layout>
  </template>
  
  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  
  export default {
    name: 'e-signature',
  
    components: {
      DashboardLayout,
    },
  
    data() {
      return {
        inProgressCount: 0,
        awaitingCount: 0,
      };
    },
  
    methods: {
      
      handleInProgressClick() {
       
      },
      handleAwaitingClick() {
       
      },
      handleHistoryClick() {
       
      },
      sendSignatureRequest() {
      
      },
    },
  };
  </script>
  
  <style scoped>
  
  .bottom-section {
  padding: 20px;
}

.card-list {
  display: flex;
  overflow-x: auto; 
}

.cardsmall {
  flex: 0 0 auto;
  width: 200px;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s;
}

.cardsmall:hover {
  transform: scale(1.05);
}

.card-thumbnail {
  width: 100%;
  height: 150px; 
  object-fit: contain;
}

.card-label {
  padding: 10px;
  background-color: #6F48FF;
  color: #fff;
  text-align: center;
  font-size: 14px;
  border-top: 1px solid #ddd;
}
  
  .top-section {
    background-color: #f2f2f2;
    padding: 20px;
  }
  
  .middle-section {
    padding: 20px;
  }
  
  .signature-image {
    max-width: 70%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 0 0px rgba(0, 0, 0, 0.1);
  }
  
  .send-request-button {
    background-color: #6F48FF;
    color: #fff;
    padding: 10px 20px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .send-request-button:hover {
    background-color: #8C6DFF;
  }
  </style>
  